let sdkPromise = null

const loadSdk = () => {
	if (window.EBWidgets) return Promise.resolve()
	if (sdkPromise) return sdkPromise

	sdkPromise = new Promise((resolve, reject) => {
		const s = document.createElement('script')
		s.src = 'https://www.eventbrite.co.uk/static/widgets/eb_widgets.js'
		s.async = true
		s.onload = resolve
		s.onerror = () => {
			sdkPromise = null
			reject(new Error('Failed to load Eventbrite widget SDK'))
		}
		document.head.appendChild(s)
	})
	return sdkPromise
}

const getTargetHeight = () =>
	Math.min(1200, Math.max(600, Math.round(window.innerHeight * 0.85)))

const resizeWidgets = () => {
	const h = getTargetHeight()
	document.querySelectorAll('[data-eventbrite-init="true"]').forEach((container) => {
		container.style.height = `${h}px`
		const iframe = container.querySelector('iframe')
		if (iframe) iframe.setAttribute('height', String(h))
	})
}

const bindResizeOnce = () => {
	if (window.__eventbriteResizeBound) return
	window.__eventbriteResizeBound = true
	let raf = 0
	window.addEventListener('resize', () => {
		cancelAnimationFrame(raf)
		raf = requestAnimationFrame(resizeWidgets)
	})
}

export const initEventbrite = () => {
	const containers = document.querySelectorAll('[data-eventbrite-id]:not([data-eventbrite-init])')
	if (!containers.length) return

	loadSdk()
		.then(() => {
			containers.forEach((container) => {
				const eventId = container.dataset.eventbriteId
				if (!eventId) return

				container.dataset.eventbriteInit = 'true'
				window.EBWidgets.createWidget({
					widgetType: 'checkout',
					eventId,
					iframeContainerId: container.id,
					iframeContainerHeight: getTargetHeight(),
					themeSettings: {
						brandColor: '#01273B',
						fontColor: '#01273B',
						background: '#F4F4F1',
					},
					onOrderComplete: () => {
						console.log('Eventbrite order complete', { eventId })
					},
				})
			})
			bindResizeOnce()
		})
		.catch((err) => console.warn(err))
}

export default () => {}
